"use strict";

var _core = require("@emotion/core");

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Breadcrumb = exports.BreadcrumbItem = void 0;

var React = __importStar(require("react")); // @ts-ignore


var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var core_1 = require("@emotion/core");

var utils_2 = require("../../utils");

var lseds_1 = require("../../lseds");

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

var foundation_1 = require("../../theme/foundation");

exports.BreadcrumbItem = utils_2.forwardRef(function Breadcrumb(props, ref) {
  var label = props.label,
      root = props.root,
      icon = props.icon,
      isFirst = props.isFirst,
      isLast = props.isLast,
      link = props.link,
      rest = __rest(props, ["label", "root", "icon", "isFirst", "isLast", "link"]);

  var defaultStyle = core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t", ";\n\t\tdisplay: flex;\n\t\tmin-height: 60px;\n\t\tfont-weight: ", ";\n\t\tcolor: ", ";\n\t\talign-items: center;\n\t\tcursor: ", ";\n\t\ttext-decoration: none;\n\t\t&:before {\n\t\t\tcontent: '';\n\t\t\theight: 34px;\n\t\t\twidth: 2px;\n\t\t\tborder-radius: 2px;\n\t\t\tbackground: ", ";\n\t\t\tposition: relative;\n\t\t\ttransform: rotate(15deg);\n\t\t\tmargin-left: 2em;\n\t\t\tmargin-right: 2em;\n\t\t\tcolor: ", ";\n\t\t\t", ";\n\t\t}\n\t"], ["\n\t\t", ";\n\t\tdisplay: flex;\n\t\tmin-height: 60px;\n\t\tfont-weight: ", ";\n\t\tcolor: ", ";\n\t\talign-items: center;\n\t\tcursor: ", ";\n\t\ttext-decoration: none;\n\t\t&:before {\n\t\t\tcontent: '';\n\t\t\theight: 34px;\n\t\t\twidth: 2px;\n\t\t\tborder-radius: 2px;\n\t\t\tbackground: ", ";\n\t\t\tposition: relative;\n\t\t\ttransform: rotate(15deg);\n\t\t\tmargin-left: 2em;\n\t\t\tmargin-right: 2em;\n\t\t\tcolor: ", ";\n\t\t\t", ";\n\t\t}\n\t"])), isFirst && 'margin-left: 30px;', isLast ? '800' : '500', root ? foundation_1.colors.primary.green : foundation_1.colors.black, link ? 'pointer' : 'default', foundation_1.colors.graphical.strokes, foundation_1.colors.graphical.strokes, isFirst && 'display: none;');
  var meta = {};

  if (link) {
    meta.href = link;
  }

  return (0, _core.jsx)(lseds_1.lseds.a, _extends({
    css: defaultStyle
  }, meta), label, root && icon && (0, _core.jsx)(react_fontawesome_1.FontAwesomeIcon, {
    icon: icon
  }));
});
exports.Breadcrumb = utils_2.forwardRef(function Breadcrumb(props, ref) {
  var disabled = props.disabled,
      noMargin = props.noMargin;
  var defaultStyle = core_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\tborder-radius: 2em;\n\t\tcursor: ", ";\n\t\tbackground-color: transparent;\n\t\tcolor: ", ";\n\t\tborder: none;\n\t\tfont-size: 1em;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\theight: 1.25em;\n\t\t", "\n\t"], ["\n\t\tborder-radius: 2em;\n\t\tcursor: ", ";\n\t\tbackground-color: transparent;\n\t\tcolor: ", ";\n\t\tborder: none;\n\t\tfont-size: 1em;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\theight: 1.25em;\n\t\t", "\n\t"])), disabled ? 'not-allowed' : 'pointer', foundation_1.colors.black, !noMargin && 'margin-bottom: 1em;');
  return (0, _core.jsx)(lseds_1.lseds.div, {
    css: defaultStyle
  }, React.Children.map(props.children, function (child, index) {
    return React.cloneElement(child, __assign(__assign({}, props), {
      isFirst: index === 0,
      isLast: index === props.children.length - 1
    }));
  }));
});

if (utils_1.isDev) {
  exports.Breadcrumb.displayName = 'Breadcrumb';
}

var templateObject_1, templateObject_2;